import request from '@/utils/request'

let Ma_conference_classificationApi = {

  /*会议分类列表*/
  list(data) {
    return request._post('/shop/plus.ma_conference_classification.Index/index', data);
},
/*添加会议分类*/
add(data) {
    return request._post('/shop/plus.ma_conference_classification.Index/add', data);
},
/*修改会议分类*/
edit(data) {
    return request._post('/shop/plus.ma_conference_classification.Index/edit', data);
},
/*删除会议分类*/
del(data) {
    return request._post('/shop/plus.ma_conference_classification.Index/del', data);
},
/*会议分类详情*/
detail(data) {
  return request._post('/shop/plus.ma_conference_classification.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_conference_classification.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_conference_classification.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.ma_conference_classification.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.ma_conference_classification.Index/export', data);
    },
}
export default Ma_conference_classificationApi;



// WEBPACK FOOTER //
// ./src/api/ma_conference_classification.js